"use client"

import { useState } from "react"
import {
  Calendar,
  MapPin,
  Users,
  Star,
  Eye,
  Clock,
  CheckCircle,
  XCircle,
  AlertCircle,
  Trash2,
  MessageSquare,
  Download,
} from "lucide-react"
import { format } from "date-fns"
import { es } from "date-fns/locale"
import { jsPDF } from "jspdf"
import { Badge } from "../UI/badge"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../UI/tabs"
import { Input } from "../UI/Input"
import { Link } from "react-router-dom"
import { Button } from "../UI/Button"
import { Card, CardContent } from "../UI/Card"
import Spinner from "../UI/Spinner/Spinner"
import Error from "../../pages/Error/Index"
import { myHeaders } from "../../config/axios"
import { URL_API } from "../../config/default"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useAppContext } from "../../contexts/AppProvider"
import Pagination from "../../utils/pagination"
import { Qualy } from "../../utils/qualy"
import ReviewModal from "../UI/review-modal"
import CancelModal from "../UI/cancel-modal"
import { CustomToast } from "../../utils/custom-toast"

export default function MyBookingsOverview() {
  const queryClient = useQueryClient();
  const { me }: any = useAppContext();
  const [searchTerm, setSearchTerm] = useState("")
  const [activeTab, setActiveTab] = useState("all")
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [motivo, setMotivo] = useState<any>("");
  const [loading, setLoading] = useState<any>(false);
  const [calificacion, setCalificacion] = useState({
    description: "",
    cleanliness: 0,
    truthgulness: 0,
    checkin: 0,
    communication: 0,
    location: 0,
    price_quality: 0,
    user: [0],
  });
  const [filter, setFilter] = useState<{
    end_date?: any;
    start_date?: any;
    status?: any;
    customer?: string;
  }>({
    customer: me?.id
  });

  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "calificar":
        {
          setLoading(true);
          let formdata = new FormData();
          if (value.property_id)
            formdata.append("property_id", value.property_id);
          if (value.excursion_id)
            formdata.append("excursion_id", value.excursion_id);

          formdata.append("booking_id", value.id);
          formdata.append("description", calificacion.description);
          formdata.append("cleanliness", String(calificacion.cleanliness));
          formdata.append("truthgulness", String(calificacion.truthgulness));
          formdata.append("checkin", String(calificacion.checkin));
          formdata.append("communication", String(calificacion.communication));
          formdata.append("location", String(calificacion.location));
          formdata.append("price_quality", String(calificacion.price_quality));

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };
          fetch(`${URL_API}/reviews`, requestOptions)
            .then(async (response) => {
              //const result: any = await response.json();
              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title: "Reseña enviada",
                });

                setCalificacion({
                  description: "",
                  cleanliness: 0,
                  truthgulness: 0,
                  checkin: 0,
                  communication: 0,
                  location: 0,
                  price_quality: 0,
                  user: [0],
                });

                setLoading(false);
                setSelectedBooking(null);
                setShowCancelModal(false);
              }
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "cancelar":
        {
          setLoading(true);
          let formdata = new FormData();
          formdata.append("status", "cancel");
          formdata.append("motivo", motivo);
          formdata.append("owner_id", selectedBooking.property[0].owner_id);
          formdata.append("property", selectedBooking.property[0].title);
          formdata.append("customer_email", selectedBooking.customer[0].email);
          formdata.append("phone", selectedBooking.customer[0].phone);

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders,
            },
          };
          fetch(`${URL_API}/reservations/${selectedBooking.id}`, requestOptions)
            .then(async (response) => {
              const result: any = await response.json();
              console.log(result);
              if (response.ok) {
                CustomToast({
                  status: 200,
                  msg: "",
                  title:
                    "Reserva cancelada. el propietario se comunicara via mail o numero de telefono proximamente",
                });

                queryClient.invalidateQueries({
                  queryKey: ["mis-reservas", filter],
                });

                setLoading(false);
                setSelectedBooking(null);
                setShowCancelModal(false);
              }

              //return navigate("/");
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      default:
        break;
    }
  };

  // Filter functions for each tab
  const getTabFilter = (tab: string) => {
    const baseFilter = { customer: me?.id };
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (tab) {
      case "upcoming":
        return {
          ...baseFilter,
          start_date: today.toISOString().split('T')[0],
          status: "pending"
        };
      case "completed":
        return {
          ...baseFilter,
          end_date: today.toISOString().split('T')[0],
          status: "completed,approved"
        };
      case "cancelled":
        return {
          ...baseFilter,
          status: "cancel"
        };
      default:
        return baseFilter;
    }
  };

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "confirmed":
        return (
          <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
            <CheckCircle className="w-3 h-3 mr-1" />
            Confirmada
          </Badge>
        )
      case "completed":
        return (
          <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-100">
            <CheckCircle className="w-3 h-3 mr-1" />
            Completada
          </Badge>
        )
      case "cancelled":
        return (
          <Badge className="bg-red-100 text-red-800 hover:bg-red-100">
            <XCircle className="w-3 h-3 mr-1" />
            Cancelada
          </Badge>
        )
      case "pending":
        return (
          <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
            <Clock className="w-3 h-3 mr-1" />
            Pendiente
          </Badge>
        )
      default:
        return <Badge variant="secondary">{status}</Badge>
    }
  }

  const handleOpenReview = (booking: any) => {
    setSelectedBooking(booking);
    setShowReviewModal(true);
  };

  const handleOpenCancel = (booking: any) => {
    setSelectedBooking(booking);
    setShowCancelModal(true);
  };

  const handleDownloadPDF = (booking: any) => {
    const doc = new jsPDF();
    const title = booking.property_id ? booking.property[0].title : booking.excursion[0].title;
    const city = booking.property_id ? booking.property[0].city : booking.excursion[0].city;
    const sellerName = booking?.seller?.length > 0
      ? `${booking?.seller[0].firstname} ${booking?.seller[0].lastname}`
      : '-';

    // Título
    doc.setFontSize(20);
    doc.text('Comprobante de Reserva', 105, 20, { align: 'center' });

    // Línea divisoria
    doc.setLineWidth(0.5);
    doc.line(20, 25, 190, 25);

    // Información de la reserva
    doc.setFontSize(12);
    doc.text('Detalles de la Reserva', 20, 35);

    doc.setFontSize(10);
    let y = 45;

    doc.text(`Código de Reserva: ${booking.id}`, 20, y);
    y += 8;

    doc.text(`Alojamiento: ${title}`, 20, y);
    y += 8;

    doc.text(`Ubicación: ${city}`, 20, y);
    y += 8;

    doc.text(`Anfitrión: ${sellerName}`, 20, y);
    y += 8;

    doc.text(`Estado: ${booking.status === 'approved' ? 'Aprobada' : 'Completada'}`, 20, y);
    y += 15;

    // Fechas
    doc.setFontSize(12);
    doc.text('Fechas de Estadía', 20, y);
    y += 10;

    doc.setFontSize(10);
    doc.text(`Check-in: ${format(new Date(booking.start_date), "dd 'de' MMMM yyyy", { locale: es })} - ${booking.checkin}`, 20, y);
    y += 8;

    doc.text(`Check-out: ${format(new Date(booking.end_date), "dd 'de' MMMM yyyy", { locale: es })} - ${booking.checkout}`, 20, y);
    y += 8;

    doc.text(`Noches: ${booking.nights}`, 20, y);
    y += 15;

    // Huéspedes
    doc.setFontSize(12);
    doc.text('Información de Huéspedes', 20, y);
    y += 10;

    doc.setFontSize(10);
    doc.text(`Cantidad de huéspedes: ${booking.guests}`, 20, y);
    y += 15;

    // Precio
    doc.setFontSize(12);
    doc.text('Desglose de Precios', 20, y);
    y += 10;

    doc.setFontSize(10);
    doc.text(`Total: $${booking.total.toFixed(2)}`, 20, y);
    y += 15;

    // Calificación
    if (booking.reviews_property && booking.reviews_property.length > 0) {
      doc.setFontSize(12);
      doc.text('Calificación', 20, y);
      y += 10;

      doc.setFontSize(10);
      doc.text(`Rating: ${Qualy(booking.reviews_property).total['total']} estrellas`, 20, y);
      doc.text(`(${booking.reviews_property.length} reseñas)`, 20, y + 8);
      y += 20;
    }

    // Footer
    doc.setFontSize(8);
    doc.text(`Generado el ${format(new Date(), "dd 'de' MMMM yyyy 'a las' HH:mm", { locale: es })}`, 105, 280, { align: 'center' });

    // Guardar PDF
    doc.save(`Reserva-${booking.id}.pdf`);
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["mis-reservas", filter],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams(filter);

      return fetch(`${URL_API}/reservations?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) {
    return (
      <div className="flex justify-center items-center py-5 text-black">
        <Spinner />
      </div>
    );
  }

  if (error) return <Error />;

  const bookings = data.data;

  return (
    <div className="space-y-6 min-h-screen">
      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <TabsList className="grid w-full grid-cols-4 max-w-md">
            <TabsTrigger
              value="all"
              className="text-xs sm:text-sm"
              onClick={() => setFilter({ customer: me?.id })}
            >
              Todas
            </TabsTrigger>
            <TabsTrigger
              value="upcoming"
              className="text-xs sm:text-sm"
              onClick={() => setFilter(getTabFilter("upcoming"))}
            >
              Próximas
            </TabsTrigger>
            <TabsTrigger
              value="completed"
              className="text-xs sm:text-sm"
              onClick={() => setFilter(getTabFilter("completed"))}
            >
              Completadas
            </TabsTrigger>
            <TabsTrigger
              value="cancelled"
              className="text-xs sm:text-sm"
              onClick={() => setFilter(getTabFilter("cancelled"))}
            >
              Canceladas
            </TabsTrigger>
          </TabsList>

          <div className="w-full sm:w-auto">
            <Input
              placeholder="Buscar reservas..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="max-w-sm"
            />
          </div>
        </div>

        <TabsContent value={activeTab} className="space-y-6">
          {bookings.length === 0 ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Calendar className="w-8 h-8 text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No hay reservas</h3>
              <p className="text-gray-600 mb-4">No tienes reservas en esta categoría.</p>
              <Link to="/">
                <Button className="bg-[#8B9456] hover:bg-[#7A8249]">Explorar alojamientos</Button>
              </Link>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-6">
              {bookings.map((booking: any, index: number) => {

                const title = booking.property_id ? booking.property[0].title : booking.excursion[0].title;
                const city = booking.property_id ? booking.property[0].city : booking.excursion[0].city;
                return (
                  <Card key={index} className="overflow-hidden hover:shadow-lg transition-shadow">
                    <CardContent className="p-0">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
                        {/* Imagen */}
                        <div className="relative h-[250px]">
                          <img
                            src={booking.images_property.length > 0 ? booking.images_property[0].url : "/placeholder.svg"}
                            alt={title}
                            className="object-cover h-full w-full"
                          />
                          <div className="absolute top-3 left-3">{getStatusBadge(booking.status)}</div>
                        </div>

                        {/* Información */}
                        <div className="md:col-span-2 p-6">
                          <div className="flex flex-col h-full">
                            <div className="flex-1">
                              <div className="flex items-start justify-between mb-3">
                                <div>
                                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{title}</h3>
                                  <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
                                    <MapPin className="w-4 h-4" />
                                    <span>{city}</span>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="flex items-center gap-1">
                                      <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                                      <span className="font-medium">{Qualy(booking.reviews_property).total['total']}</span>
                                      <span className="text-sm text-gray-600">({booking.reviews_property.length})</span>
                                    </div>
                                    <span className="text-sm text-gray-600">• Anfitrión: {
                                      booking?.seller?.length > 0
                                        ? `${booking?.seller[0].firstname} ${booking?.seller[0].lastname}`
                                        : '-'
                                    }</span>
                                  </div>
                                </div>
                                <div className="text-right">
                                  <div className="text-lg font-bold text-gray-900">
                                    ${booking.total.toFixed(2)}
                                  </div>
                                  <div className="text-sm text-gray-600">total</div>
                                </div>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                                <div className="flex items-center gap-2 text-sm">
                                  <Calendar className="w-4 h-4 text-gray-400" />
                                  <div>
                                    <div className="font-medium">
                                      {format(new Date(booking.start_date), "dd MMM", { locale: es })} {booking.checkin} - {" "}
                                      {format(new Date(booking.end_date), "dd MMM yyyy", { locale: es })} {booking.checkout}
                                    </div>
                                    <div className="text-gray-600">{booking.nights} noches</div>
                                  </div>
                                </div>

                                <div className="flex items-center gap-2 text-sm">
                                  <Users className="w-4 h-4 text-gray-400" />
                                  <div>
                                    <div className="font-medium">{booking.guests} huéspedes</div>
                                    <div className="text-gray-600">Código: {booking.id}</div>
                                  </div>
                                </div>

                                <div className="flex items-center gap-2 text-sm">
                                  <AlertCircle className="w-4 h-4 text-gray-400" />
                                  <div>
                                    <div className="font-medium">Estado</div>
                                    <div className="text-gray-600">
                                      {getStatusBadge(booking.status)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Acciones */}
                            <div className="flex flex-wrap gap-2 pt-4 border-t">
                              <Button variant="outline" size="sm" className="hidden">
                                <Eye className="w-4 h-4 mr-2" />
                                Ver detalles
                              </Button>

                              <Link to={`/chat?booking_id=${booking.id}`}>
                                <Button variant="outline" size="sm">
                                  <MessageSquare className="mr-2 h-4 w-4" />
                                  Contactar anfitrión
                                </Button>
                              </Link>

                              {
                                booking.status === 'pending' || booking.status === 'pre-pending' &&
                                (<Button variant="outline" size="sm" className=""
                                  onClick={() => handleOpenCancel(booking)}>
                                  <Trash2 className="mr-2 h-4 w-4" />
                                  Cancelar
                                </Button>)
                              }

                              {(booking.status === 'approved' || booking.status === 'completed') && (
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => handleDownloadPDF(booking)}
                                >
                                  <Download className="mr-2 h-4 w-4" />
                                  Descargar PDF
                                </Button>
                              )}

                              {booking.reviews_property.length == 0 &&
                                activeTab == 'completed'
                                && (
                                  <Button size="sm" className="bg-[#8B9456] hover:bg-[#7A8249]"
                                    onClick={() => handleOpenReview(booking)}>
                                    <Star className="w-4 h-4 mr-2" />
                                    Escribir reseña
                                  </Button>
                                )}

                              {booking.reviews_property.length > 0 &&
                                activeTab == 'completed'
                                && (
                                  <Button variant="outline" size="sm"
                                    onClick={() => handleOpenReview(booking)}>
                                    <Star className="w-4 h-4 mr-2" />
                                    Ver mi reseña
                                  </Button>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )
              })}
            </div>
          )}
        </TabsContent>


        {/* Review Modal */}
        {showReviewModal && selectedBooking && (
          <ReviewModal
            onClick={onClick}
            calificacion={calificacion}
            setCalificacion={setCalificacion}
            loading={loading}
            booking={selectedBooking}
            onClose={() => {
              setShowReviewModal(false);
              setSelectedBooking(null);
            }}
          />
        )}

        {/* Cancel Modal */}
        {showCancelModal && selectedBooking && (
          <CancelModal
            onClick={onClick}
            setMotivo={setMotivo}
            loading={loading}
            motivo={motivo}
            booking={selectedBooking}
            onClose={() => {
              setShowCancelModal(false);
              setSelectedBooking(null);
            }}
          />
        )}


        {/* Pagination */}
        <Pagination data={data} setPage={setFilter} page={filter} />
      </Tabs>
    </div>
  )
}
